import { render, staticRenderFns } from "./HistoricCampaigns.vue?vue&type=template&id=21116eb0&scoped=true"
import script from "./HistoricCampaigns.vue?vue&type=script&lang=js"
export * from "./HistoricCampaigns.vue?vue&type=script&lang=js"
import style0 from "./HistoricCampaigns.vue?vue&type=style&index=0&id=21116eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21116eb0",
  null
  
)

export default component.exports